export const passwordValidator =
  (newString = "") =>
  (_, value) => {
    if (!value) {
      return Promise.reject(
        new Error(`Please enter your ${newString} password!`)
      );
    }
    const errors = [];
    if (value.length < 8) {
      errors.push("Password must be at least 8 characters!");
    }
    if (value.length > 36) {
      errors.push("Password must be less than 36 characters!");
    }
    if (!/[a-z]/.test(value)) {
      errors.push("Password must include at least one lowercase character!");
    }
    if (!/[A-Z]/.test(value)) {
      errors.push("Password must include at least one uppercase character!");
    }
    if (!/[0-9]/.test(value)) {
      errors.push("Password must include at least one numeral!");
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
      errors.push("Password must include at least one symbol!");
    }
    if (errors.length > 0) {
      return Promise.reject(new Error(errors.join(" ")));
    }
    return Promise.resolve();
  };
